import { render, staticRenderFns } from "./StudyNavigation.vue?vue&type=template&id=f2ffdda4&scoped=true&lang=pug"
import script from "./StudyNavigation.vue?vue&type=script&lang=ts"
export * from "./StudyNavigation.vue?vue&type=script&lang=ts"
import style0 from "./StudyNavigation.vue?vue&type=style&index=0&id=f2ffdda4&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f2ffdda4",
  null
  
)

export default component.exports